<template id="zarzourTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <form
      :class="formState.invalidShake?'invalid':''"
      :disabled="formState.loading"
      class="zarzour-form"
    >
      <fieldset>
        <legend>Add new Zarzour</legend>
        <div
          v-if="errors.length && formState.attempted && (!formState.loading)"
          class="col-12 col-sm-12"
        >
          <b class="w-100">Please correct the following error(s):</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>
        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Title</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="title"
              placeholder="Title"
            />
          </div>
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Title(EN)</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="titleEN"
              placeholder="Title(EN)"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Name</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="name"
              placeholder="Name"
            />
          </div>
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Name(EN)</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="nameEN"
              placeholder="Name(EN)"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Description</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="description"
              placeholder="Description"
            />
          </div>
          <div class="form-group col-12 col-sm-6">
            <label class="col-12 col-sm-4">Description(EN)</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="descriptionEN"
              placeholder="description(EN)"
            />
          </div>
        </div> -->

        <div class="form-group col-12 col-sm-12">
          <label class="col-12 col-sm-4">Parent Zarzour</label>
          <b-form-select
            :disabled="formState.loading"
            class="modified-dropdown col-12 col-sm-8"
            v-model="parentCat"
            :options="parentCats"
          ></b-form-select>
        </div>

        <!-- <div class="row">
          <div class="form-group col-12 col-sm-12">
            <label class="col-12 col-sm-12">Maximum Quantity</label>
            <input
              class="form-control col-12 col-sm-12"
              type="number"
              v-model="max_quantity"
              placeholder="ex. 50"
            >
          </div>
          <div class="form-group col-12 col-sm-12">
            <label class="col-12 col-sm-12">Cost</label>
            <input
              class="form-control col-12 col-sm-12"
              type="number"
              v-model="cost"
              placeholder="ex. 50"
            />
          </div>
        </div> -->

        <!-- <div class="row"> -->
          <!-- <div class="form-group col-12 col-sm-12">
            <label class="col-12 col-sm-12">Display in Two Rows</label>
            <input
              class="form-control col-12 col-sm-12"
              type="checkbox"
              v-model="two_row"
              placeholder="Description"
            />
          </div> -->
          <!-- <div class="form-group col-12 col-sm-12">
            <label class="col-12 col-sm-12">Multi Select</label>
            <input
              class="form-control col-12 col-sm-12"
              type="checkbox"
              v-model="multiSelect"
              placeholder="description(EN)"
            />
          </div> -->
          <!-- <div class="form-group col-12 col-sm-12">
            <label class="col-12 col-sm-12">With Accessories</label>
            <input
              class="form-control col-12 col-sm-12"
              type="checkbox"
              v-model="withAccessory"
              placeholder="description(EN)"
            />
          </div> -->
        <!-- </div> -->

        <div class="form-group col-12 col-sm-12" v-if="parentCat && parentCats.find(i=>{return i.value == parentCat}).text.trim().toLowerCase()!='type of starling'">
          <strong>
            Please use an image that has an aspect ratio of
            <br>
            1 : {{parseFloat(75/75).toFixed(2)}} (W : H) - Example: 75x75
            <br>
            Ignoring this may cause distortion of the image on the website
          </strong>
          <br />
          <small>Current File Reference, you can change the url or you can upload a new file.</small>
          <input
            class="form-control"
            type="text"
            maxlength="200"
            v-model="image.value"
            placeholder="Image URL"
            v-on:input="checkForm"
          />

          <small>To upload a new file, click choose file.</small>
          <label class="col-12 col-sm-12">Image</label>
          <input
            class="form-control-file"
            type="file"
            id="image"
            @change="uploadFile('image')"
            :disabled="formState.loading"
          />
        </div>

        <div class="col-12 col-sm-12 text-center">
          <button
            :disabled="formState.loading"
            type="button"
            v-on:click="submitNewZarzour()"
            class="btn btn-primary"
          >Add Zarzour</button>
        </div>
      </fieldset>
    </form>
  </div>
</template>


<!-- zarzour Template -->




<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.zarzour-form {
  float: right;
  padding: 50px;
  width: 80%;
  text-align: left;
  label {
    padding-left: 0;
  }

  div {
    padding: 10px;
  }

  button {
    margin: 0 auto;
    padding: 10px 30px;
    font-size: 16px;
  }
}
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
/* eslint-enable no-unused-vars*/
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import { herokuUrl } from "../apiConfig";
import logOut from "../scripts/utils";

export default {
  name: "AddZarzour",
  data() {
    return {
      errors: [],
      parentCat: "",
      title: "",
      titleEN: "",
      name: "",
      nameEN: "",
      // description: "",
      // descriptionEN: "",
      max_quantity: "",
      // cost: "",
      // two_row: false,
      // multiSelect: false,
      // withAccessory: true,
      image: {
        uploaded: null,
        newFileUpload: null,
        value: null
      },
      parentCats: [
        {
          value: null,
          text: "Please select an option"
        }
      ],
      formState: {
        attempted: false,
        invalidShake: false,
        loading: false
      }
    };
  },
  watch: {
    title: function() {
      this.checkForm();
    },
    titleEN: function() {
      this.checkForm();
    },
    name: function() {
      this.checkForm();
    },
    nameEN: function() {
      this.checkForm();
    },
    // description: function() {
    //   this.checkForm();
    // },
    // descriptionEN: function() {
    //   this.checkForm();
    // },
    parentCat: function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchZarzours();
    this.checkForm();
  },
  methods: {
    compress() {
      const width = 75;
      const height = 75;
      const fileName = document.getElementById("image").files[0].name;
      const reader = new FileReader();
      console.log(document.getElementById("image").files[0])
      reader.readAsDataURL(document.getElementById("image").files[0]);
      return reader.onload = event => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
                  const elem = document.createElement('canvas');
                  elem.width = width;
                  elem.height = height;
                  const ctx = elem.getContext('2d');
                  // img.width and img.height will contain the original dimensions
                  ctx.drawImage(img, 0, 0, width, height);
                  ctx.canvas.toBlob((blob) => {
                      const file = new File([blob], fileName, {
                          type: 'image/jpeg',
                          lastModified: Date.now()
                      });
                      this.image.newFileUpload = new FormData();
                      this.image.newFileUpload.set("images", file);
                      axios
                      .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
                        headers: {
                          "Content-Type": "application/x-www-form-urlencoded",
                          Authorization: getCookie("user")
                        }
                      })
                      .then(res => {
                        if (res.data.status) {
                          this.image.uploaded = true;
                          this.image.value = res.data.sources[0];
                          this.formState.loading = false;
                        } else {
                          alert("Couldn't Upload file, File too large or " + res.message);
                          this.formState.loading = false;
                        }
                      })
                      .catch(err => {
                        if(err.response.status == 401) {
                          logOut();
                        } else {
                          alert(
                            "Couldn't Upload file, File too large or " +
                              err.response.data.message
                          );
                          this.formState.loading = false;
                        }
                      });
                  }, 'image/jpeg', 1);
              },
              reader.onerror = error => console.log(error);
      };
    },
    // Whenever an input of type file changes, the selected file is uploaded to the backend
    uploadFile() {
      this.formState.loading = true;
      this.image.uploaded = false;
      return this.compress();
      this.image.newFileUpload = new FormData();
      let file = document.getElementById("image").files[0];
      this.image.newFileUpload.set("images", file);
      axios
        .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          if (res.data.status) {
            this.image.uploaded = true;
            this.image.value = res.data.sources[0];
            this.formState.loading = false;
          } else {
            alert("Couldn't Upload file, File too large or    " + res.message);
            this.formState.loading = false;
          }
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            alert(
              "Couldn't Upload file, File too large or    " +
                err.response.data.message
            );
            this.formState.loading = false;
          }
        });
    },
    checkForm: function() {
      this.errors = [];
      if (!this.name) {
        this.errors.push("Name is required");
      }
      if (!this.nameEN) {
        this.errors.push("Name (EN) is required");
      }
      if (!this.titleEN) {
        this.errors.push("Title (EN) is required.");
      }
      if (!this.title) {
        this.errors.push("Title is required.");
      }
      // if (!this.description) {
      //   this.errors.push("Description is required");
      // }
      // if (!this.descriptionEN) {
      //   this.errors.push("Description (EN) is required");
      // }
      if (!this.parentCat) {
        this.errors.push("Parent Zarzour is required");
      }
    },
    fetchZarzours() {
      this.formState.loading = true;
      return axios
        .get(`${herokuUrl}/dashboard/getAllparentCategories/Zarzour`, {
          headers: {
            Authorization: getCookie("user")
          }
        })
        .then(res => {
          this.formState.loading = false;
          /* eslint-disable no-console */

          /* eslint-enable no-console */
          let cats = res.data.parentCategories;
          //   let cats = [];
          let newParentCats = [
            {
              value: null,
              text: "Please select an option"
            }
          ];
          cats.forEach(element => {
            newParentCats.push({
              value: element.id,
              text: element.name_en
            });
          });
          this.parentCats = [...newParentCats];
        })
        .catch(err => {
          if(err.response.status == 401) {
            logOut();
          } else {
            alert(
              "Zarzours fetching failed," +
                err.response.data.message
            );
          }
          // window.location.reload();
        });
    },
    submitNewZarzour() {
      this.formState.attempted = true;
      if (!this.errors.length) {
        this.formState.loading = true;
        axios
          .post(
            `${herokuUrl}/dashboard/addZarzour`,
            {
              name: this.name,
              name_en: this.nameEN,
              title: this.title,
              title_en: this.titleEN,
              // description: this.description,
              // description_en: this.descriptionEN,
              parentCat: this.parentCat,
              imageSource: this.parentCat && this.parentCats.find(i=>{return i.value == this.parentCat}).text.trim().toLowerCase()!='type of starling'?this.image.value: undefined,
              max_quantity: this.max_quantity,
              // cost: this.cost,
              // two_row: this.two_row,
              // multiSelect: this.multiSelect,
              // withAccessory: this.withAccessory
            },
            {
              headers: {
                Authorization: getCookie("user")
              }
            }
          )
          .then(() => {
            this.formState.loading = false;
            this.formState.attempted = false;
            alert("Zarzour was added successfully");
            window.location.reload();
          })
          .catch(err => {
            if(err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert(
                "There was an error, " +
                  err.response.data.message
              );
            }
          });
      } else {
        this.shakeForm();
      }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function() {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    }
  },
  components: {
    appNavigation: Navigation
  }
};
</script>
